interface ArbitrumIconProps {
  className?: string
}

export function ArbitrumIcon({ className }: ArbitrumIconProps) {
  return (
    <svg viewBox="0 0 238 238" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_4057_1924)">
        <path
          d="M25.668 74.3076V163.693C25.668 169.4 28.7167 174.676 33.6545 177.52L111.032 222.222C115.969 225.066 122.048 225.066 126.986 222.222L204.363 177.52C209.301 174.676 212.35 169.4 212.35 163.693V74.3076C212.35 68.6005 209.301 63.3239 204.363 60.4797L126.986 15.7779C122.048 12.9337 115.969 12.9337 111.032 15.7779L33.6357 60.4797C28.698 63.3239 25.668 68.6005 25.668 74.3076Z"
          fill="#213147"
        />
        <path
          d="M135.889 136.336L124.853 166.611C124.554 167.453 124.554 168.37 124.853 169.212L143.838 221.305L165.796 208.619L139.442 136.336C138.844 134.671 136.487 134.671 135.889 136.336Z"
          fill="#12AAFF"
        />
        <path
          d="M158.015 85.4221C157.416 83.7568 155.059 83.7568 154.461 85.4221L143.426 115.697C143.126 116.539 143.126 117.456 143.426 118.298L174.53 203.585L196.488 190.899L158.015 85.4221Z"
          fill="#12AAFF"
        />
        <path
          d="M119 19.1272C119.542 19.1272 120.085 19.2769 120.571 19.5389L204.308 67.9082C205.28 68.4695 205.879 69.5174 205.879 70.6213V167.341C205.879 168.464 205.28 169.493 204.308 170.054L120.571 218.424C120.104 218.704 119.542 218.835 119 218.835C118.458 218.835 117.915 218.686 117.429 218.424L33.6924 170.092C32.7198 169.53 32.1213 168.483 32.1213 167.379V70.64C32.1213 69.5174 32.7198 68.4882 33.6924 67.9269L117.429 19.5576C117.915 19.2769 118.458 19.1272 119 19.1272ZM119 5C116.026 5 113.034 5.76717 110.359 7.32023L26.6411 55.6708C21.2919 58.7582 18 64.4652 18 70.64V167.36C18 173.535 21.2919 179.242 26.6411 182.329L110.378 230.698C113.052 232.233 116.026 233.019 119.019 233.019C121.993 233.019 124.985 232.252 127.66 230.698L211.396 182.329C216.746 179.242 220.037 173.535 220.037 167.36V70.64C220.037 64.4652 216.746 58.7582 211.396 55.6708L127.641 7.32023C124.966 5.76717 121.974 5 119 5Z"
          fill="#9DCCED"
        />
        <path
          d="M63.6191 203.698L71.3251 182.591L86.8304 195.483L72.3351 208.731L63.6191 203.698Z"
          fill="#213147"
        />
        <path
          d="M111.949 63.7168H90.72C89.1301 63.7168 87.7087 64.7085 87.1663 66.2054L41.6602 191.011L63.6183 203.698L113.726 66.2616C114.193 65.0266 113.277 63.7168 111.949 63.7168Z"
          fill="white"
        />
        <path
          d="M149.095 63.7168H127.866C126.276 63.7168 124.855 64.7085 124.312 66.2054L72.3535 208.712L94.3117 221.399L150.872 66.2616C151.321 65.0266 150.404 63.7168 149.095 63.7168Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4057_1924">
          <rect width="202" height="228" fill="white" transform="translate(18 5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
